export function ShortIdUtil(id: string) {
  try {
    if(id?.length >= 4) {
      return (id.substring(0, 3) + "-" + id.substring(3, 5))
        .toString()
        .toUpperCase();
    }    
  } catch (e) {
    return id;
  }

  return id;
}
